(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.web
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]
   [frontend.ui.component.lp-portal.report.body.voima.fund.web :refer [subheading]]
   [frontend.ui.component.lp-portal.report.component.block-table.view :as block-table]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.view :as horizontal-table]
   [frontend.ui.component.lp-portal.report.component.image.view :as image]
   [frontend.ui.component.lp-portal.report.component.vertical-table.view :as vertical-table]
   [frontend.ui.component.lp-portal.voima-components.card.view :refer [card]]
   [frontend.ui.component.lp-portal.voima-components.free-text-card.free-text-card :as free-text-card]
   [frontend.ui.component.lp-portal.voima-components.section.style :as style]
   [frontend.ui.component.lp-portal.voima-components.section.view :as section]
   [frontend.ui.component.table.view :as table]
   [frontend.ui.style.theme.core :as theme]
   [herb.core :refer [<class]]
   [reagent.core :as r]))

(defn toggle-button
  [toggled?]
  [:button
   {:on-click (fn [_exp]
                (reset! toggled? (not @toggled?))
                (deref toggled?))
    :style    {:display          "inline-block"
               :margin           "4px 0"
               :padding          "4px 12px"
               :white-space      "nowrap"
               :background-color "white"
               :color            (theme/color [:badge :exited-investment :fg])
               :border-color     (theme/color [:badge :exited-investment :fg])
               :border           "0.5px solid"
               :font-weight      "bold"
               :border-radius    (theme/border-radius :xxxsmall)
               :font-size        "15px"}}
   (if @toggled?
     "Click for Team letter in English"
     "Click for Team letter in Finnish")])

(defn team-letter-section
  [_props]
  (let [toggled? (r/atom false)]
    (fn [{:keys [letter-text letter-text-2 letter-text-finnish letter-text-2-finnish letter-image]} props]
      [section/section
       [:div
        [:div
         {:style {:display     :flex
                  :justify-content :space-between
                  :align-items :flex-end
                  :gap         :16px}}
         [:div
          {:style {:display   :inline-flex
                   :max-width :200px}}
          [:div {:class (<class style/holding-header)} "Team letter"]]
         [:div
          {:style {:padding-top :16px}}
          (when-not (and (cu/empty-value? (:rich-content letter-text-finnish))
                         (cu/empty-value? (:rich-content letter-text-2-finnish))
                         (not (:edit-mode? props)))
            [toggle-button toggled?])]]]
       (str "team-letter-"
            (some->> props
                     :report
                     :db/id))
       (if @toggled?
         ^{:key "team-letter-finnish"}
         [card {:title ""}
          [grid/row {}
           [grid/column {:large 6}
            [free-text-card/free-text-section "" letter-text-finnish props]]
           [grid/column {:large 6}
            [free-text-card/free-text-section "" letter-text-2-finnish props]
            [image/image (if (cu/blank-value? (:image letter-image)) "Add image (optional)" "") letter-image props false]]]]
         ^{:key "team-letter-english"}
         [card {:title ""}
          [grid/row {}
           [grid/column {:large 6}
            [free-text-card/free-text-section "" letter-text props]]
           [grid/column {:large 6}
            [free-text-card/free-text-section "" letter-text-2 props]
            [image/image (if (cu/blank-value? (:image letter-image)) "Add image (optional)" "") letter-image props false]]]])])))

(defn fund-overview-section
  [{:keys [fund-overview-1 fund-overview-image]} props]
  (let [block-table-config {:border?        false
                            :hide-footnote? true}]
    [section/section "Fund overview"
     (str "fund-overview-"
          (some->> props
                   :report
                   :db/id))
     [card {:title ""}
      [grid/row {}
       [grid/column {:large 12}
        [table/editable-table fund-overview-1 props
         [block-table/table "" fund-overview-1 (merge props block-table-config)]]
        [image/image
         (if (cu/blank-value? (:image fund-overview-image))
           "Add image (optional)"
           "") fund-overview-image (merge props {:hide-footnote? true}) false]]]]]))

(defn tech-fund-overview-section
  [{:keys [fund-overview-1 fund-overview-2 case-overview fund-overview-image] :as _data} props]
  (let [block-table-config {:border?        false
                            :hide-footnote? true}]
    [section/section "Fund overview"
     (str "fund-overview-tech-"
          (some->> props
                   :report
                   :db/id))
     [card {:title ""}
      [grid/row {}
       [grid/column {:large 6}
        [table/editable-table fund-overview-1 props
         [block-table/table "" fund-overview-1 (merge props block-table-config)]]
        [free-text-card/free-text-section "" case-overview props]]
       [grid/column {:large 6}
        [table/editable-table fund-overview-2 props
         [block-table/table "" fund-overview-2 (merge props block-table-config)]]
        [image/image
         (if (cu/blank-value? (:image fund-overview-image))
           "Add image (optional)"
           "") fund-overview-image (merge props {:hide-footnote? true}) false]]]]]))

(defn esg-summary
  [{:keys [esg-summary esg-image]} props]
  [section/section "ESG summary"
   (str "esg-"
        (some->> props
                 :report
                 :db/id))
   [card {:title ""}
    [grid/row {}
     [grid/column {:large 6}
      [free-text-card/free-text-section "" esg-summary props]]
     [grid/column {:large 6}
      [image/image (if (cu/blank-value? (:image esg-image)) "Add image (optional)" "") esg-image props false]]]]])

(defn fund-status-section
  [{:keys [net-asset-value
           key-metrics
           capital-account-since-inception]
    :as   data} props]
  [section/section "Fund financial summary"
   (str "finance-summary-"
        (some->> props
                 :report
                 :db/id))
   [:div
    (when-not (and (empty-table-data? data :net-asset-value)
                   (empty-table-data? data :key-metrics))
      [subheading "Fund performance tables"])
    [table/editable-table net-asset-value props
     [horizontal-table/table "" net-asset-value props]]
    [:div {:style {:margin-top "12px"}}]
    [table/editable-table key-metrics props
     [vertical-table/table "" key-metrics props]]
    [:div {:style {:margin-top "12px"}}]
    [table/editable-table capital-account-since-inception props
     [horizontal-table/table "Capital accounts table" capital-account-since-inception props]]]])

(defn portfolio-information-section
  [{:keys [portfolio-summary] :as portfolio-information} props]
  (let [hide-section? (and (empty-table-data? portfolio-information :portfolio-summary)
                           (not (:edit-mode? props)))]
    (when-not hide-section?
      [section/section "Portfolio information"
       (str "portfolio-information-"
            (some->> props
                     :report
                     :db/id))
       [:div
        [table/editable-table portfolio-summary props
         [horizontal-table/table "Portfolio summary" portfolio-summary props]]]])))

#_(defn investor-information-section
    [{:keys [capital-account-year-to-date capital-account-since-inception] :as investor-information} props]
    (let [hide-section? (and (empty-table-data? investor-information :capital-account-year-to-date)
                             (empty-table-data? investor-information :capital-account-since-inception)
                             (not (:edit-mode? props)))]
      (when-not hide-section?
        [section/section "Investor information"
         (str "investor-information-"
              (some->> props
                       :report
                       :db/id))
         [:div
          [table/editable-table capital-account-since-inception props
           [horizontal-table/table "Capital account (since inception)" capital-account-since-inception props]]
          [table/editable-table capital-account-year-to-date props
           [horizontal-table/table "Capital account (year to date)" capital-account-year-to-date props]]]])))

(defn fees-interest-expenses-section
  [{:keys [management-fees transaction-and-other-fees
           carried-interest fund-operating-expenses]
    :as   data} props]
  (let [hide-section? (and (empty-table-data? data :management-fees)
                           (empty-table-data? data :transaction-and-other-fees)
                           (empty-table-data? data :carried-interest)
                           (empty-table-data? data :fund-operating-expenses))
        table-config {:fixed-width? true}]
    (when-not (and hide-section? (not (:edit-mode? props)))
      [section/section "GP fees, carried interest and fund operating expenses"
       (str "fees-interest-expenses-"
            (some->> props
                     :report
                     :db/id))
       [table/editable-table management-fees props
        [vertical-table/table "" management-fees (merge table-config props)]]
       [:div {:style {:margin-top "12px"}}]
       [table/editable-table transaction-and-other-fees props
        [vertical-table/table "" transaction-and-other-fees (merge table-config props)]]
       [:div {:style {:margin-top "12px"}}]
       [table/editable-table carried-interest props
        [vertical-table/table "" carried-interest (merge table-config props)]]
       [:div {:style {:margin-top "12px"}}]
       [table/editable-table fund-operating-expenses props
        [vertical-table/table "" fund-operating-expenses (merge table-config props)]]])))

(defn report-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [fund-overview esg fund-status portfolio-information team-letter]} fund-ui-data]
    [:div
     [:div
      {:id :team-letter}
      [:div
       [team-letter-section team-letter props]]]
     [:div {:id :fund-overview}
      [:div
       [fund-overview-section fund-overview props]]]
     [:div {:id :esg}
      [:div
       [esg-summary esg props]]]
     [:div {:id :fund-information}
      [:div
       [fund-status-section fund-status props]]]
     #_[:div {:id :investor-information}
        [:div
         [investor-information-section investor-information props]]]
     [:div {:id :fees-interest-expenses}
      [:div
       [fees-interest-expenses-section fund-status props]]]
     [:div {:id :portfolio-information}
      [:div
       [portfolio-information-section portfolio-information props]]]]))

(defn tech-fund-report-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [fund-overview fund-status portfolio-information team-letter]} fund-ui-data]
    [:div
     [:div
      {:id :team-letter}
      [:div
       [team-letter-section team-letter props]]]
     [:div {:id :fund-overview}
      [:div
       [tech-fund-overview-section fund-overview props]]]
     [:div {:id :fund-information}
      [:div
       [fund-status-section fund-status props]]]
     [:div {:id :fees-interest-expenses}
      [:div
       [fees-interest-expenses-section fund-status props]]]
     [:div {:id :portfolio-information}
      [:div
       [portfolio-information-section portfolio-information props]]]]))

(defn feeder-view
  [{:keys [fund-ui-data] :as props}]
  (let [{:keys [fund-overview fund-status]} fund-ui-data]
    [:div
     [:div {:id :fund-overview}
      [:div
       [fund-overview-section fund-overview props]]]
     [:div {:id :fund-information}
      [:div
       [fund-status-section fund-status props]]]]))


